import { useQueries } from "react-query";

export const useMultiQuery = (keys: string[] = [], func: (key: string) => any) => {
    return useQueries(keys.map((key) => ({ queryKey: key, queryFn: () => func(key), enabled: keys.length > 0 })));
};

//This is where I want to put the mutations and useQueries
